import { Loader } from './Loader'

/**
 * Inline-кружок (старый API) — сохранён для обратной совместимости в местах,
 * где нужен маленький спиннер внутри текста/кнопки. Для новых сценариев
 * используй <Loader variant="bus" /> или <Loader variant="ring" />.
 */
export function Spinner({ className = '' }: { className?: string }) {
  return (
    <div
      className={`animate-spin rounded-full border-2 border-gray-200 border-t-brand-600 ${className}`}
    />
  )
}

/**
 * Страничный лоадер — брендовый знак micro·hub, спутники вращаются вокруг
 * ядра. Единая точка входа: все страницы при первичной загрузке показывают
 * его. Для специальных сценариев (формы, прогресс) — использовать <Loader/>
 * напрямую.
 */
export function PageLoader({ label }: { label?: string } = {}) {
  return (
    <div className="flex items-center justify-center py-16">
      <Loader variant="brand" size={72} label={label} />
    </div>
  )
}
